'use es6';

import generate from './generate.js';
export default generate;